import { getHighlightedDates } from "./getHighlightedDates";

const _defaultHighlightedDates = getHighlightedDates();

export function defaultHighlightedDates() {
  return {
    computed: {
      highlightedDates() {
        return _defaultHighlightedDates;
      },
    },
  };
}
